/* eslint-disable react/no-children-prop */
import { Link } from 'react-admin'
import { Checkbox, Chip, makeStyles, Typography } from '@material-ui/core'
import config from '../../config'

const useStyles = makeStyles(() => ({
  pillStyle: {
    margin: '3px',
    backgroundColor: '#FFF2CC',
    cursor: 'pointer',
  },
}))

/**
 * This component is the base to render any link on the copro manager dashboard
 *
 * @param {
 *   path: string,
 *   filter: Object
 * } props
 *
 * @returns Link
 */
const InternalLinkRender = ({ path, filter, children }) => (
  <Link
    color="primary"
    to={{
      pathname: path,
      search: `filter=${JSON.stringify(filter)}`,
    }}
    children={children}
  />
)

/**
 * This is being used to render the Chip into the copro manager dashboard.
 *
 * @param {
 *   value: any
 * } props``
 *
 * @returns Chip
 */
export const Pill = ({ value }) => {
  const classes = useStyles()

  return <Chip size="small" className={classes.pillStyle} label={value} />
}

/**
 * This will render a Pill with a link
 *
 * @param {
 *   value: Any,
 *   link: string,
 *   filter: Object
 * } props
 * @returns Link
 */
export const PillLink = ({ value, link, filter }) => (
  <InternalLinkRender
    path={link}
    filter={filter}
    children={<Pill value={value} />}
  />
)
/**
 * Render a Typography component with the shorten text if maxLenght parameter is present
 *
 * @param {
 *   value: string,
 *   maxLenght: number | undefined,
 *   className: string
 * } props
 *
 * @returns Typography
 */
export const SimpleText = ({ value: rawValue, maxLength = 0, className }) => {
  let value
  if (maxLength > 0 && rawValue) {
    value = rawValue.substring(0, maxLength)
    value += value === rawValue ? '' : '...'
  }

  return (
    <Typography className={className} align="left" variant="body2">
      {value || rawValue}
    </Typography>
  )
}

/**
 * Create a Link with a text with the given max length
 *
 * @param {
 *   value: string
 *   maxLength: number | undefined,
 *   className: string
 *   path: string,
 *   filter: Object
 * } props
 *
 *
 * @returns Link
 */
export const SimpleTextLink = ({
  value,
  className,
  maxLength,
  path,
  filter,
}) => (
  <InternalLinkRender
    path={path}
    filter={filter}
    children={
      <SimpleText value={value} maxLength={maxLength} className={className} />
    }
  />
)

/**
 * This component allow to render a Checkbox and update a value of the if the updateData is setted.
 *
 * @param {
 *   value: Any,
 *   disabled: boolean,
 *   updateData: {
 *      uri,
 *      [valueName]: newValue,
 *   } | undefined | null
 * } props
 *
 * @todo: Find a better way to secure requests. I do not see how sending a auth_token harcoded string can be useful
 * @see [hello-front/src/dataProvider.js:8] In the front we pass auth_token harcoded value
 * @see [hello-back/server.js:106] In the back we check against a auth_token harcoded value
 *
 * @returns Checkbox
 */
export const Boolean = ({
  value,
  disabled,
  detail_update_resource,
  fieldName,
  onChange,
}) => {
  return (
    <Checkbox
      align="left"
      variant="body2"
      defaultChecked={value}
      onClick={(e) => {
        if (fieldName)
          fetch(detail_update_resource, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              auth_token: config.auth_token,
            },
            body: JSON.stringify({ [fieldName]: e.target.checked }),
          }).then((result) => {
            if (onChange) onChange(e, result)
          })
      }}
      disabled={disabled}
    />
  )
}
